import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue } from 'redux-form';
import { Link } from 'react-router-dom';
import Titulo from '../comum/Titulo';
import {
    getFinanceiroAgencia,
    getFinanceiroCaixa,
    getPerfisEmpresa,
    PERFIL_ADMIN,
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import { buscarBagagens, alterarExibicaoBagagem } from '../../actions/bagagem/bagagemActions';
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import Bagagem from './Bagagem';
import PainelFiltragem from './PainelFiltrosBagagem';
import CampoSelecionarEmpresa from '../layout/CampoSelecionarEmpresa';
import { alterouFiltro, alterouPagina } from '../../util/filtros';

export const CabecalhoTabela = () => (
    <div id="header-tabela" className="lista-table d-md-block d-lg-block d-xl-block d-none d-sm-none">
      <div className="row cabecalho-desktop">
        <div className="col">Exibir detalhes</div>
        <div className="col">Nº Reserva</div>
        <div className="col">Identificador</div>
        <div className="col">Passageiro</div>
        <div className="col">Vendedor</div>
        <div className="col">Situação</div>
        <div className="col">Data emissão</div>
        <div className="col">Valor</div>
        <div className="col">Peso</div>
        <div className="col">Ações</div>
      </div>
    </div>
  );

export class PainelGerenciarBagagenss extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            arquivos: [],
            imagensInformarEntrega: [],
            historicos: [],
            idPedido: null
        };
    }

    componentDidMount() {
        if (this.props.empresaSelecionada.id) {
            this.buscarBagagens()
        }
    }

    buscarBagagens() {
        this.props.buscarBagagens(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps) || alterouFiltro(this.props, prevProps) || alterouPagina(this.props, prevProps)) {
            this.buscarBagagens()
        }
    }


    exibirBagagens() {
        return this.props.bagagens
            .map((bagagem, index) => <Bagagem key={index} bagagem={bagagem} indice={index} />)
    }

    exibirTabelaBagagens() {
        if (this.props.bagagens && this.props.bagagens.length) {
            return (<div className='mt-4'>
                     <CabecalhoTabela />
                    <div className="lista-table">
                        {this.exibirBagagens()}
                    </div>
            </div>
            )
        }
        return <div>Nenhuma bagagem cadastrada</div>;
    }

    exibirFiltro() {
        return <div className="row">
            <div className="col-md-6">
                <Link to="/painel-pesquisar-bilhete">
                    <button className="btn btn-laranja">
                        <i className="material-icons mr-1" style={{
                            fontSize: '18px',
                            verticalAlign: 'middle'
                        }}>
                            &#xe145;
                        </i>
                        Nova Bagagem
                    </button>
                </Link>
            </div>
            <div className="col-md-6">
                <div className="text-right">
                    <PainelFiltragem/>
                </div>
            </div>
        </div>
    }


    render() {
            return (
                <Autorizacao perfisPermitidos={[PERFIL_ADMIN, ...getPerfisEmpresa(this.props.empresaSelecionada.id),
                    getFinanceiroAgencia(this.props.empresaSelecionada.id),
                     getFinanceiroCaixa(this.props.empresaSelecionada.id)]}
                    empresaSelecionada={this.props.empresaSelecionada}>
                    <div>
                        <div className="row internas">
                            <Titulo texto="Gerenciar bagagens" urlRetorno="/menu-bagagem" />
                            { this.exibirFiltro() }
                            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                                <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                                    <ul className="nav navbar-nav ml-auto opcoes-menu menu-desktop">
                                        <li className="nav-item dropdown nome-empresa">
                                            <div className='col-md-6'>
                                                <CampoSelecionarEmpresa />
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </Autorizacao>
                            <div className="col-12 filtro-busca">
                            </div>
                            <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                                {this.exibirTabelaBagagens()}
                            </div>
                        </div>
                    </div>
                    
                </Autorizacao>
            )
    }
}


export const mapStateToProps = state => (
    {
        empresaSelecionada: state.empresaSelecionada,
        bagagens: state.bagagem.lista,
        paginaAtual: state.paginaAtualBagagem,
        registrosPorPagina: state.registrosPorPaginaBagagem,
        filtrosAdicionados: state.filtrosAdicionadosBagagem,
        bagagemSelecionada: state.bagagemSelecionada,
        changeFieldValue,
    });


export default connect(mapStateToProps,
    {
        buscarBagagens,
        alterarExibicaoBagagem,
    })(PainelGerenciarBagagenss)
